/**
 * Whether a redirect target stays inside the app: a path, never an absolute or
 * protocol-relative URL (`//host`, and `/\\host`, which browsers read the same).
 * Control characters are refused anywhere: a browser drops tab and newline from
 * a URL, so `/<tab>/host` would become `//host`.
 */
export function isSafeRedirectPath(path: string): boolean {
	return (
		path.startsWith("/") &&
		!path.startsWith("//") &&
		!path.startsWith("/\\") &&
		!hasControlCharacter(path)
	);
}

function hasControlCharacter(path: string): boolean {
	for (let i = 0; i < path.length; i++) {
		const code = path.charCodeAt(i);
		if (code < 0x20 || code === 0x7f) {
			return true;
		}
	}
	return false;
}

/** The post-login destination, query included, or `/home` for anything unsafe. */
export function safeRedirectHref(redirect: string | undefined): string {
	return redirect !== undefined && isSafeRedirectPath(redirect)
		? redirect
		: "/home";
}
